import React from 'react'
import styled from 'styled-components'
import { Icon, InlineIcon } from '@iconify/react';
import checkSolid from '@iconify/icons-la/check-solid';
import plusSolid from '@iconify/icons-la/plus-solid';
import bxDownload from '@iconify/icons-bx/bx-download';
import refreshIcon from '@iconify/icons-ei/refresh';
import { fetchReports } from '../../store/data-export/reportsSlice'
import { useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import { getHost } from '../../api/host'
// https://www.robinwieruch.de/react-hooks-fetch-data
// https://dev.to/bdbch/react-hooks-for-data-part-1-fetching-data-28ge
// https://github.com/naisutech/react-tree

const ListContainer = styled.div`
  width: 100%;
  background: transaprent;
  padding: 5px 20px;
  
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0;
  }
`;

interface ListContainerLi {
  background?: string;
}

const ListContainerLi = styled.li<ListContainerLi>`
  background: transparent;
  color: #555;
  padding: 6px 10px;
  position: relative;

  // &:hover {
  //   background: #F2F2F2;
  //   cursor: pointer;
  // }
`;

const ListHeading = styled.div`
  color: #333;
  font-size: 14px;
  padding: 10px 0px 20px 0;
  text-align: center;
  // border-bottom: 1px solid #ddd;
`;

const Tick = styled(Icon)`
  color: #555;
  padding: 0 5px;
  line-height: 0;
  right: 5px;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%) rotate(0) !important;
  transform: translateY(-50%) rotate(0) !important;
`;

const DownloadIcon = styled(Icon)`
  color: #555;
  padding: 0 5px;
  cursor: pointer;
`;

const Plus = styled(Icon)`
  color: #555;
  right: 10px;
  position: absolute;
  line-height: 0;
  top: 50%;
  -ms-transform: translateY(-50%) rotate(0) !important;
  transform: translateY(-50%) rotate(0) !important;
`;

const HeadingTable = styled.table`
`;

const Table = styled.table`
  overflow-y: scroll;
  height: 480px;
  display: block;
`;

const Row = styled.tr`
  height: 30px;
`;

const HeadingCell = styled.th`
  font-size: 14px;
  color: #555;
  text-align: left;
  padding: 0 10px 10px 10px;
  font-weight: normal;
`;

const Cell = styled.td`
  font-size: 12px;
  color: #555555;
  padding: 0px 10px;
  vertical-align: middle;
`;

const CellDownload = styled.td`
`;

const StyledType = styled.div<{scheduled: boolean}>`
  text-align: center;
  width: 25px;
  padding: 5px 0;
  background: ${props => props.scheduled? '#ade6bb' : '#add8e6'};
  border: 1px solid #ddd;
`;

const Type = ({ scheduled }: { scheduled: boolean }) => {
  
  return (
    <StyledType scheduled={scheduled}>
      {scheduled? 'S' : 'M'}
    </StyledType>
  )
}

const StyledRecipientsPopup = styled.div`
  position: absolute;
  display: none;
  border: 1px solid #ddd;
  padding: 10px;
  background: #fff;
  z-index: 99;
  width: 150px;
`;

const StyledRecipient = styled.div`
  padding: 5px 0;
`;

const RecipientsPopup = ({ recipients }: { recipients: any }) => {
  return (
    <StyledRecipientsPopup>
      {recipients.map((recipient, index) => (
        <StyledRecipient key={index}>
          {recipient.first_name} {recipient.last_name}
        </StyledRecipient>
      ))}
    </StyledRecipientsPopup>
  )
}

const StyledRecipients = styled.div`
  position: relative;

  &:hover {
    cursor: default;
  }

  &:hover ${StyledRecipientsPopup} {
    display: block;
  }
`;

const Recipients = ({ recipients, onDelete }: { recipients: any[]; onDelete?: Function }) => {

  var short_string = '';

  if (recipients.length > 0) {
    short_string = recipients[0].first_name.toString() || '';
  
    for (let i = 1; i < recipients.length; i++) {
      
      if (short_string.length < 10) {
        short_string += `, ${recipients[i].first_name.toString()}`;
      } else {
        short_string += '...'
        break;
      }
    }
  } 
  
  return (
    <StyledRecipients>
      <div>{short_string}</div>
      <RecipientsPopup recipients={recipients}/>
    </StyledRecipients>
  )
}

const ReportStatusPopup = styled.div`
  position: absolute;
  display: none;
  padding: 10px;
  top: -25px;
  left: 5px;
  color: #555;
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
`;

const ReportStatus = styled.div<{status: number}>`
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: ${props => status_colour_lookup[props.status]};
  margin: 0 auto;
  
  &:hover ${ReportStatusPopup} {
    display: block;
  }
`;

const status_colour_lookup = [
  '#5b63fc',
  '#fc5b5b',
  '#ade6bb'
]

const status_lookup = [
  'Pending',
  'Failed',
  'Completed'
]

const RefreshContainer = styled.div`
  position: absolute;
  color: #999;
  top: 8px;
  right: 20px;
  cursor: pointer;
`;

const DownloadDiv = styled.div`
  height: 30px;
`;

const lookupPeriodName = {
  day: 'Daily',
  week: 'Weekly'
}

export const ReportList = ({ templates, reports, station }: any) => {
  
  const lookupTemplateName = (template_id) => {
    return templates.filter((template) => template.report_template_id == template_id)[0].title || 'Default';
  }
  
  const dispatch = useDispatch()
  
  return (
    <ListContainer>
      <RefreshContainer onClick={() => {dispatch(fetchReports(station.id))}}><Icon  width='40px' height='40px' color='#555' icon={refreshIcon} /></RefreshContainer>
      <ListHeading>Generated Reports</ListHeading>
      <Table>
        <Row>
          <HeadingCell></HeadingCell>
          <HeadingCell>Report Start Date</HeadingCell>
          <HeadingCell>Generated</HeadingCell>
          {false && <HeadingCell>Period</HeadingCell>}
          <HeadingCell>Template</HeadingCell>
          <HeadingCell>Recipients</HeadingCell>
          <HeadingCell>Status</HeadingCell>
        </Row>
      {reports.map((item, index) => (
        <Row key={index}>
          <Cell>{false?<Type scheduled={item.report_schedule_id !== null? true : false}/>:null}</Cell>
          <Cell>{moment(item.start).format('YYYY-MM-DD')}</Cell>
          <Cell>{moment.utc(item.created).tz(station.timezone).format('YYYY-MM-DD HH:mm')}</Cell>
          {false && <Cell>{lookupPeriodName[item.period]}</Cell>}
          <Cell>{lookupTemplateName(item.template_id)}</Cell>
          <Cell><Recipients recipients={item.recipients}/></Cell>
          <Cell><ReportStatus status={item.status}><ReportStatusPopup>{status_lookup[item.status]}</ReportStatusPopup></ReportStatus></Cell>
          <Cell onClick={() => {window.location.href = `https://${getHost()}/reports/download/${item.report_id}`}}>
            {item.status == 2?
              <DownloadIcon align='middle' width='30px' height='30px' icon={bxDownload}/>
            : null}
          </Cell>
        </Row>
      ))}
      </Table>
    </ListContainer>
  )
}